<mat-sidenav-container class="initial-container">
  <router-outlet></router-outlet>
  <div class="versions">
    <p>Front End Version: {{ frontEndVersion }}</p>
    <p>Back End Version: {{ backEndVersion }}</p>
  </div>
</mat-sidenav-container>
